import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowUp16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M7.25012 3.81074L3.53051 7.53035L2.46985 6.46969L8.00018 0.939362L13.5305 6.46969L12.4698 7.53035L8.75012 3.81063L8.75012 15H7.25012L7.25012 3.81074Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowUp16.displayName = 'ArrowUp16';
export default ArrowUp16;
